var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"h2 text-center",style:(_vm.color.length > 0 && `color: ${_vm.color};`)},[_vm._v("\n      "+_vm._s(_vm.header)+"\n   ")]),(_vm.description)?_c('p',{staticClass:"text-center modified-css"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n   ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }